// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_COLUMN_HEADINGS = {
  price: 'Price',
  size: 'Size',
};
